import React from 'react';
export function SocialProofBar() {
  return <div className="bg-[#1a365d] py-4 border-y border-slate-700" data-id="element-142">
      <div className="max-w-6xl mx-auto px-4" data-id="element-143">
        <p className="text-center text-slate-300 text-xs font-semibold tracking-widest uppercase mb-2.5" data-id="element-144">
          Utilizado en todo tipo de contextos:
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-white font-medium text-xs md:text-sm opacity-90" data-id="element-145">
          <span data-id="element-146">Escuelas Públicas</span>
          <span className="text-slate-500" data-id="element-147">·</span>
          <span data-id="element-148">Colegios Privados</span>
          <span className="text-slate-500" data-id="element-149">·</span>
          <span data-id="element-150">Institutos Técnicos</span>
          <span className="text-slate-500" data-id="element-151">·</span>
          <span data-id="element-152">Bachilleratos</span>
          <span className="text-slate-500" data-id="element-153">·</span>
          <span data-id="element-154">Escuelas de Adultos</span>
          <span className="text-slate-500" data-id="element-155">·</span>
          <span data-id="element-156">Educación a Distancia</span>
        </div>
      </div>
    </div>;
}